import { get, put, post, Success } from './methods';

export interface Pergunta {
  dataDuvida: string;
  dataResposta: string | null;
  duvida: string;
  idDuvidaFrequente: number | string;
  lido: boolean;
  resposta: string | null;
  usuarioDuvida: string;
  flgDestaque: boolean;
}

export type ListaPerguntas = Pergunta[];

interface PerguntarPayload {
  duvida: string;
  idEvento: number;
  usuario: string;
}

const duvidasFrequentes = {
  listar: (idEvento: number) => {
    const endpoint = 'duvida-frequente/duvida-evento';
    return get<ListaPerguntas>(endpoint, {
      params: { idEvento },
    });
  },
  perguntar: (data: PerguntarPayload) => {
    const endpoint = 'duvida-frequente/registra-duvida';
    return post<Pergunta>(endpoint, data);
  },
  lido: (idDuvida: number | string) => {
    const endpoint = `duvida-frequente/${idDuvida}/lido`;
    return put<Success>(endpoint);
  },
};

export default duvidasFrequentes;
